import axios from 'axios';

export const getToken = () => (
	axios.defaults.headers.common['Authorization']
);
